import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-ye",
  "use": "icon-icon-ye-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\" id=\"icon-icon-ye\">\n  <g fill-rule=\"evenodd\" stroke-width=\"1pt\">\n    <path fill=\"#fff\" d=\"M0 0h512v504.3H0z\" />\n    <path fill=\"#f10600\" d=\"M0 0h512v167.9H0z\" />\n    <path d=\"M0 344.1h512V512H0z\" />\n  </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol